import { render, staticRenderFns } from "./base-column-count.vue?vue&type=template&id=15fd75f4&scoped=true&"
import script from "./base-column-count.vue?vue&type=script&lang=js&"
export * from "./base-column-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fd75f4",
  null
  
)

export default component.exports